import React from 'react';
export function IntroSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-4432">
      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-4433">
        The selection of EDM wire used to be easy as there were only a few
        choices; copper or brass. Today, there are more electrode choices for
        wire EDM than there are for sinkers. We have economy and utility-grade
        wires, wires for speed, wires for carbide and PCD's, wires for tapering,
        and fine-wire machining. In this short study, we will first examine the
        different properties of EDM wire, then we will briefly examine the
        different types of wires and their applications.
      </p>
    </div>;
}